import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
`;

export const QuestsWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 16px;
	align-items: stretch;

	@media (max-width: 1800px) {
		grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	}
`;

export const Title = styled.h2`
	margin: 0;
	font-size: 40px;
	line-height: 47px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 24px;
`;
